import { Link } from "react-router";
import { AuthGate } from "../app/AuthGate";
import { AppShell } from "../app/layouts/AppShell";
import { PublicLayout } from "../app/layouts/PublicLayout";
import { useMeQuery } from "../app/session";
import { s } from "../app/strings";
import { useDocumentTitle } from "../app/title";
import { FullPageSpinner } from "../ui/Spinner";
import styles from "./NotFound.module.css";

export function NotFoundContent() {
  useDocumentTitle("Page not found");
  return (
    <section className={styles.wrap}>
      <div className={styles.code} aria-hidden="true">
        404
      </div>
      <h1 className={styles.title}>{s.notFoundTitle}</h1>
      <p className={styles.line}>{s.notFoundLine1}</p>
      <p className={styles.line}>
        {s.notFoundLine2} <Link to="/">{s.notFoundLink}</Link>
      </p>
      <p className={styles.footer}>{s.notFoundFooter}</p>
    </section>
  );
}

/** Inside the shell when logged in, inside the auth card otherwise (shell spec section 8). */
export function NotFoundPage() {
  const me = useMeQuery();
  if (me.isPending) return <FullPageSpinner />;
  if (me.data) {
    return (
      <AuthGate>
        <AppShell>
          <NotFoundContent />
        </AppShell>
      </AuthGate>
    );
  }
  return (
    <PublicLayout>
      <NotFoundContent />
    </PublicLayout>
  );
}
